import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Fade, Slide, Button, Stack } from "@mui/material";
import { MWhatsNewsService } from "../../services/MWhatsNewsService";
import { globalService } from "../../services/GlobalService";
import useForm from "../../utility/hooks/UseForm";
import { AuthContext } from "../../utility/context/AuthContext";
import { CircularProgress } from "@mui/material";

const DisplayWhatsNew = (props: {
  onClose: () => void;
  displayWhatsNewMode: "unseen" | "all";
}) => {
  const { onClose, displayWhatsNewMode } = props;
  const [whatsnewOpenvalue, setWhatsnewOpenvalue] = React.useState(false);
  const scrollTimerRef = useRef<any>(null);
  const [whatsNewViewedBysids, setWhatsNewViewedBysids] = useState([]);
  const [mWhatNews, setMWhatsNews] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [show, setShow] = useState(true);
  const [autoScroll, setAutoScroll] = useState(true);
  const { auth, setAuth } = React.useContext(AuthContext);
  useEffect(() => {
    if (displayWhatsNewMode === "unseen") {
      ViewMWhatsNews();
    } else if (displayWhatsNewMode === "all") {
      getAllByActive();
    }
  }, []);

  useEffect(() => {
    if (mWhatNews.length === 0 || !autoScroll) return;

    // Delay auto-scroll start for first message
    const delayBeforeFirstScroll = setTimeout(() => {
      scrollTimerRef.current = setInterval(() => {
        setShow(false);
        setTimeout(() => {
          setCurrentIndex((prev) => (prev + 1) % mWhatNews.length);
          setShow(true);
        }, 800);
      }, 10000);
    }, 3000); // 3s delay for first message

    return () => {
      clearTimeout(delayBeforeFirstScroll);
      if (scrollTimerRef.current) clearInterval(scrollTimerRef.current);
    };
  }, [mWhatNews, autoScroll]);

  const ViewMWhatsNews = () => {
    var currentUserId = auth.UserId;
    MWhatsNewsService.ViewMWhatsNews(currentUserId).then((response) => {
      let result = response.data;
      const ids = result.list.map((item: any) => item.WhatsNewId);
      setMWhatsNews(result.list);
      setWhatsNewViewedBysids(ids);
      if (ids.length > 0) {
        setWhatsnewOpenvalue(true);
      } else {
        setWhatsnewOpenvalue(false); // Or show toast like "No new updates"
      }
    });
  };

  const getAllByActive = () => {
    MWhatsNewsService.getAllByActive().then((response) => {
      let result = response.data;
      const ids = result.list.map((item: any) => item.WhatsNewId);
      setMWhatsNews(result.list);
      setWhatsNewViewedBysids(ids);
    });
  };

  const handlePrev = () => {
    setAutoScroll(true);
    setShow(false);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === 0 ? mWhatNews.length - 1 : prev - 1));
      setShow(true);
    }, 300);
  };

  const validate = (fieldValues = values) => {
    let temp: any = { ...errors };

    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((x) => x === "");
  };
  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(MWhatsNewsService.initialFieldValues, validate, "");

  const newUser = () => {
    setValues(MWhatsNewsService.initialFieldValues);
  };

  const handleNext = () => {
    setAutoScroll(true);
    setShow(false);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev + 1) % mWhatNews.length);
      setShow(true);
    }, 300);
  };
console.log( props.onClose);
  const AddWhatsNewViewedBys = () => {
    values.WhatsNewIds = whatsNewViewedBysids;
    values.WhatsNewViewedByName = auth.UserName;
    MWhatsNewsService.AddWhatsNewViewedBys(values).then((response: any) => {
      if (response) {
        let result = response.data;
        if (result.isSuccess) {
          debugger;
          globalService.success(result.message);
          //props.onClose();
           window.location.reload(); 
        } else {
          globalService.error(result.message);
        }
      }
    });
  };

  // };

  const news = mWhatNews[currentIndex];
  // if (mWhatNews.length === 0) {
  //   return (
  //     <Box sx={{ textAlign: "center", mt: 5 }}>
  //       <CircularProgress color="primary" />
  //       <Typography variant="body2" mt={2}>
  //         📢 What's New
  //       </Typography>
  //     </Box>
  //   );
  // }

  return (
    <>
      <Typography
        variant="h6"
        align="center"
        gutterBottom
        sx={{ fontWeight: "bold", color: "#0b0b5b" }}
      >
        📢 What's New
      </Typography>

      {news && (
        <Fade in={show} timeout={700}>
          <Box
            sx={{
              //mx: "auto",
              maxWidth: "none",
              backgroundColor: "#e3f2fd",
              borderRadius: 4,
              boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
              transition: "all 0.3s ease-in-out",
              // p: 3,
            }}
          >
            <Typography
              variant="h5"
              align="center"
              sx={{
                fontWeight: "bold",
                color: "#0d47a1",
                borderBottom: "3px solid #64b5f6",
                pb: 1,
              }}
            >
              {news.WhatsNewTitle}
            </Typography>

            <Stack direction="row" alignItems="flex-start" spacing={2}>
              {/* Left Button */}

              <Slide
                direction="left"
                in={show}
                timeout={700}
                mountOnEnter
                unmountOnExit
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    background: "#ffffff",
                    borderRadius: 3,
                    // p: 2,
                    boxShadow: "inset 0 0 10px rgba(0,0,0,0.05)",
                    maxWidth: "100%",
                    width: "100%",
                  }}
                >
                  {/* Previous Button on the left */}
                  <Button onClick={handlePrev}>◀</Button>

                  {/* Center Content */}
                  <Box
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 400,
                      color: "#1a237e",
                      lineHeight: 1.9,
                      width: "100%",
                      flexGrow: 1,
                      maxHeight: "800px", // You can adjust height as needed
                      overflowY: "auto", // Enables vertical scroll
                      paddingRight: 2, // Optional: adds space for scrollbar
                    }}
                    dangerouslySetInnerHTML={{ __html: news.WhatsNew }}
                  />

                  {/* Next Button on the right */}
                  <Button onClick={handleNext}>▶</Button>
                </Box>
              </Slide>

              {/* Right Button */}
            </Stack>
          </Box>
        </Fade>
      )}

      <Box sx={{ mt: 3, textAlign: "center" }}>
        <Button
          variant="contained"
          size="medium"
          onClick={
            displayWhatsNewMode === "unseen"
              ? AddWhatsNewViewedBys
              : props.onClose
          }
          sx={{
            backgroundColor: "#0b0b5b",
            "&:hover": {
              backgroundColor: "#1a237e",
            },
          }}
        >
          Close
        </Button>
      </Box>
    </>
  );
};

export default DisplayWhatsNew;
